export const HASHES = {
    AVAILABLE_POSITIONS: 'positions',
}

export const QUERY_KEYS = {
    FIELD_TYPE: 't',
    FORM: 'f',
    LOCATION: 'l',
    COMPANY: 'c'
}

export const ROUTES = {
    HOME: 'home',
    PRIVACY: 'privacy'
}